module.exports = __webpack_public_path__ + "dd82cf771fc5aee0481ac12c69c07405.svg";